var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrimaryKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2AF6F0",
    fillRule: "evenodd",
    d: "M1.12327 1.86128C0.956626 2.42628 0.922636 3.01141 1.0213 3.61666C1.18361 4.61235 1.90096 5.48103 2.52759 5.89096C3.18293 6.31967 3.89524 6.53294 4.66451 6.53077C4.514 6.63363 4.35332 6.72316 4.18423 6.79764V10.7736L2.96882 12L1.75013 10.7736V10.2831L2.41449 9.66215L1.75013 9.102L1.74823 8.65744L2.41449 8.09877L1.75013 7.47786V6.79619C0.718271 6.34021 0 5.323 0 4.14132C0 3.21766 0.438845 2.39449 1.12327 1.86128ZM4.61645 0C6.25608 0 7.58527 1.32856 7.58527 2.96743C7.58527 3.08252 7.57871 3.19608 7.56596 3.30776L7.54221 3.47382L11.6426 6.23572L12 7.94202L10.2815 8.25274L9.70257 7.86242L9.54902 6.95792L8.70385 7.18909L8.32685 6.93722L8.227 6.06662L7.33045 6.26316L6.18337 5.48836C5.72858 5.77137 5.19162 5.93486 4.61645 5.93486C2.97681 5.93486 1.64763 4.6063 1.64763 2.96743C1.64763 1.32856 2.97681 0 4.61645 0ZM3.63298 1.50886C3.19574 1.50886 2.84129 1.86314 2.84129 2.30018C2.84129 2.73721 3.19574 3.09149 3.63298 3.09149C4.07021 3.09149 4.42466 2.73721 4.42466 2.30018C4.42466 1.86314 4.07021 1.50886 3.63298 1.50886Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimaryKey);
export default __webpack_public_path__ + "static/media/primary-key.61f8736d3abeaa4b8a39898fa6b21c40.svg";
export { ForwardRef as ReactComponent };